import { render, staticRenderFns } from "./VehicleCreateCheckListView.vue?vue&type=template&id=33d48f80&scoped=true&"
import script from "./VehicleCreateCheckListView.vue?vue&type=script&lang=js&"
export * from "./VehicleCreateCheckListView.vue?vue&type=script&lang=js&"
import style0 from "./VehicleCreateCheckListView.vue?vue&type=style&index=0&id=33d48f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d48f80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCol,VContainer,VDivider,VRow,VSheet})
